<template>
  <div>
    <weekdays class="flix-form-group" />
    <div
      class="flix-flex flix-flex-list flix-gap-10 flix-form-group flix-mt-50"
      style="align-items: flex-start"
    >
      <h4>
        {{ $t("time.period.title") }} <help>{{ $t("time.period.info") }}</help>
      </h4>
      <div class="flix-flex flix-flex-inline flix-flex-center flix-gap-10">
        <div class="flix-html-small">
          {{ $t("time.period.description").split("{date}")[0] }}
        </div>
        <startDate class="item" />
        <div class="flix-html-small">
          {{ $t("time.period.description").split("{date}")[1] }}
        </div>
        <endDate class="item" />
        <div class="flix-html-small">
          {{ $t("time.period.description").split("{date}")[2] }}
        </div>
      </div>
      <checkDate />
    </div>
    <saveBtn v-if="checkData()" class="saveBtn" :callback="setSave" />
  </div>
</template>
<script>
export default {
  components: {
    weekdays() {
      return import("@/components/business/time/weekdays");
    },
    startDate() {
      return import("@/components/business/time/startDate");
    },
    checkDate() {
      return import("@/components/business/time/checkDate");
    },
    endDate() {
      return import("@/components/business/time/endDate");
    }
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    setSave() {
      this.changeNextAppointments();
      this.$store.commit("business/update", this.$store.state.business.unsaved);
      this.$router.push({ name: "settings" });
    },
    changeNextAppointments() {
      var data = JSON.parse(JSON.stringify(this.$store.state.business.unsaved));

      Object.keys(data.include.weekdays).forEach(function(day) {
        data.next_appointments[day] = false;
      });
      this.$store.commit("business/prefetch", data);
    },
    checkData() {
      var data = JSON.parse(JSON.stringify(this.$store.state.business.unsaved));
      if (!Object.keys(data.include.weekdays).length) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="sass" scoped></style>
